/**
=========================================================
* Otis Kit PRO - v2.0.1
=========================================================

* Product Page: https://material-ui.com/store/items/otis-kit-pro-material-kit-react/
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import routes from "routes";

// Otis Kit PRO themes
import theme from "assets/theme";
import LandingPage from "layouts/pages/landing-pages/landing";
import CareersPage from "layouts/pages/landing-pages/careers";
import RequestPage from "layouts/pages/landing-pages/requests";
import RequestDetailPage from "./pages/Quotes/RequestDetail";
import PoliciesPage from "./pages/Support/Policies";
import TechnologyPage from "./pages/Technology";

// Otis Kit PRO routes

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {getRoutes(routes)}
        <Route path="/" element={<LandingPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/requests" element={<RequestPage />} />
        <Route path="/requests/:request_id" element={<RequestDetailPage />} />
        <Route path="/policies" element={<PoliciesPage />} />
        <Route path="/technology" element={<TechnologyPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </ThemeProvider>
  );
}
